import React from 'react'
import { createUseStyles } from 'react-jss'
import DispatchService from '../../services/DispatcherService'

import View from '../form/View'

const logo = require('../../assets/logo.png')
const useStyles = createUseStyles(theme => ({
  content: {
    justifyContent: 'space-between',
    flexDirection: 'column',
    overflowX: 'hidden',
    padding: '32px',
    
    '@media(min-width: 500px)': {
      background: '#ffffff',
      position: 'relative',
      width: '100%',
      maxWidth: '400px',
      boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15)',
      borderRadius: '16px',
      zIndex: 10,
    }
  },
  logo: {
    alignItems: 'center',
    justifyContent: 'center',
    margin: '14px 0'
  },
  logoImg: {
    width: '60%',
    objectFit: 'contain'
  },
  title: {   
    justifyContent: 'center',
    textAlign: 'center',
    fontFamily: 'Fira Sans, sans serif',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '32px',
    color: '#2AC769',
    margin: '14px 0',
  },  
  message: {
    margin: '14px 0',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '18px',
    color: '#454545'
  },
  bold: {
    fontWeight: 'bold'
  },
  link: {
    cursor: 'pointer',
    textDecoration: 'underline',
    color: theme.colors.secondary
  }
}))

function SignupCompleted () {
  const styles = useStyles()

  const domain = DispatchService.getManagerConfig().domain;

  return (
    <View className={styles.content}>
      <View className={styles.logo}>
        <img src={logo} alt="Logo" className={styles.logoImg} />
      </View>
      <View className={styles.title}>
        Seu cadastro foi realizado com sucesso!
      </View>
      
      <View className={`${styles.message} ${styles.bold}`}>    
        <span>Para começar a utilizar o TOPTIC GO, instale o aplicativo no seu dispositivo <a className={styles.link} href="https://play.google.com/store/apps/details?id=br.com.toptic.go">Android</a> ou <a className={styles.link} href="https://apps.apple.com/br/app/toptic-go/id1541763716?l=en">IOS</a> =)</span>
      </View>

      <View className={styles.message}>
        Ou acesse a nosso portal web: <a className={styles.link} href={`https://${domain}/portal`}>{domain}/portal</a>
      </View>
    </View>
  )
}

export default SignupCompleted